import { getFunctions, httpsCallable } from 'firebase/functions';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

// Initialize Functions with europe-west3 region
const functions = getFunctions(undefined, 'europe-west3');

/**
 * Save or update an activity resource
 * @param {string} activitySlug - The slug of the activity
 * @param {Object} resource - The resource object to save
 * @param {number} [resourceIndex] - Optional index if updating existing resource
 * @returns {Promise<Object>} The saved resource
 */
export async function saveActivityResource(activitySlug, resource, resourceIndex) {
  try {
    const saveResource = httpsCallable(functions, 'saveActivityResourceFunc');
    const result = await saveResource({
      activitySlug,
      resource,
      resourceIndex,
    });
    return result.data;
  } catch (error) {
    console.error('Error saving activity resource:', error);
    if (error.code === 'already-exists') {
      throw new Error('RESOURCE_URL_NOT_UNIQUE');
    }
    throw error;
  }
}

/**
 * Get activity by slug from Firestore
 * @param {string} slug - The activity slug
 * @returns {Promise<Object>} The activity document data
 */
export async function getActivityBySlug(slug) {
  try {
    // Query by slug field
    const { collection, query, where, getDocs } = await import('firebase/firestore');
    const q = query(collection(db, 'kb_items'), where('slug', '==', slug));
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      // Fallback: try document ID
      const docRef = doc(db, 'kb_items', slug);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
      }
      throw new Error('Activity not found');
    }
    
    const docSnap = snapshot.docs[0];
    return { id: docSnap.id, ...docSnap.data() };
  } catch (error) {
    console.error('Error getting activity by slug:', error);
    throw error;
  }
}








